import { Component, ViewChild, OnInit } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

const moment = _rollupMoment || _moment;

export const YYYY_MM = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY年MM月',
    monthYearLabel: 'YYYY年MM月',
    dateA11yLabel: 'YYYY年MM月',
    monthYearA11yLabel: 'YYYY年MM月',
  },
};

@Component({
  selector: 'app-account-archived',
  templateUrl: './account-archived.component.html',
  styleUrls: ['./account-archived.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: YYYY_MM },
  ],
})
export class AccountArchivedComponent implements OnInit {

  @ViewChild('picker', { static: true }) datePicker?: MatDatepicker<Date>;

  maxDate = new Date();
  dateInput = new FormControl();
  monthControl = new FormControl();
  monthLabel = '';

  constructor(_dateAdapter: DateAdapter<MomentDateAdapter>) {
    _dateAdapter.setLocale('ja-JP');
  }

  ngOnInit() {
    this.dateInput.valueChanges.subscribe(
      value => {
        this.monthLabel = moment(value).format('YYYY-MM');
        this.monthControl.setValue(moment(value).format('YYYY年MM月'));
      }
    );
    this.dateInput.setValue(moment().add(-1, 'month').toDate());
  }

  onMonthSelected(date: Date) {
    this.dateInput.setValue(date);
    this.datePicker?.close();
  }
}
